import React, { useEffect, useState } from 'react';
import PageHeading from '../../../components/PageHeading';
import { useDispatch, useSelector } from 'react-redux';
import CardBasic from '../../../components/Cards/Basic';
import { formatCurrency } from '../../../constants/utility';
import Skeleton from 'react-loading-skeleton';
import TextInput from '../../../components/TextInput';
import { Controller, useForm } from 'react-hook-form';
import { fetchBarang, fetchGudangStok, fetchShipping, setFormOrder } from '../../../redux/actions/transaction';
import { createAccountAddress, deleteAccountAddress, updateAccountAddress } from '../../../redux/actions/account';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import CardAlamat from '../RiwayatTransaksi/CreateTransaksi/component/CardAlamat';
import ModalDetailItem from '../RiwayatTransaksi/CreateTransaksi/component/ModalDetailItem';
import ModalAlamat from '../../../components/Modal/ModalAlamat';
import { toast } from 'react-toastify';
import { fetchProvinces } from '../../../redux/actions/regions';

const CekOngkir = (props) => {
  const {
    register,
    formState: { errors },
    setValue,
    control,
    watch,
    handleSubmit
  } = useForm({ mode: "onChange" });

  const dispatch = useDispatch();
  const { title } = props.data;
  const { address } = useSelector((state) => state.account);
  const [detailProduct, setDetailProduct] = useState(false)
  const { barang, formOrder, gudang, shipping } = useSelector((state) => state.transaction);
  const [posisi, setPosisi] = useState('PLATINUM')
  const [carts, setCarts] = useState([]);
  const [selected, setSelected] = useState(null);
  const [modal, setModal] = useState(false)
  const [optLayanan, setOptLayanan] = useState([]);
  const [optEkspedisi, setOptEkspedisi] = useState([]);
  const [myEkspedisi, setMyEkspedisi] = useState(null);
  const [formAddress, setFormAddress] = useState(null);
  const watchEkspedisi = watch("ekspedisi");
  const [subsidiOngkir, setSubsidiOngkir] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [selectedSearchAddress, setSelectedSearchAddress] = useState('');

  useEffect(() => {
    if (formAddress?.public_id) {
      setValue("public_id", formAddress?.public_id || "");
    }
  }, [formAddress, setValue]);

  useEffect(() => {
    dispatch(fetchBarang());
  }, [dispatch]);


  const handleViewItemDetail = (index, e) => {
    if (e.target.type === 'button') return;
    setModalData(index);
    setDetailProduct(true);
  };

  const handleQty = (item, qty) => {
    const totalbv = carts?.reduce((a, b) => a + b.qty * b.value, 0) + qty * item.value;
    let bvmax

    if (posisi === 'BRONZE') {
      bvmax = 1
    } else if (posisi === 'SILVER') {
      bvmax = 2
    } else if (posisi === 'PLATINUM') {
      bvmax = 4
    }


    if (totalbv > bvmax && bvmax > 0) return;
    if (qty === 0) {
      const tmpCarts = carts?.filter((a) => a.public_id !== item.public_id, []);
      setCarts(tmpCarts);
    } else {
      const check = carts?.find((a) => a.public_id === item.public_id);
      if (!check) {
        setCarts([
          ...carts,
          {
            public_id: item.public_id,
            nama: item.nama,
            harga: item.harga,
            value: item.value,
            berat: item.berat,
            dpp: item.dpp,
            persen_ppn: item.persen_ppn,
            qty: qty,
          },
        ]);
      } else {
        const tmpCarts = carts
          ?.map((a) => {
            if (a.public_id === item.public_id) {
              return {
                ...a,
                qty: a.qty + qty,
              };
            }
            return a;
          }, [])
          .filter((filter) => filter.qty > 0, []);
        setCarts(tmpCarts);
      }
    }
  };
  const [disableMax, setDisambleMax] = useState(false);

  useEffect(() => {
    const totalbv = carts?.reduce((a, b) => a + b.qty * b.value, 0);
    let bvmax
    if (posisi === 'BRONZE') {
      bvmax = 1
    } else if (posisi === 'SILVER') {
      bvmax = 2
    } else if (posisi === 'PLATINUM') {
      bvmax = 4
    }

    setDisambleMax(totalbv >= bvmax && bvmax > 0);
  }, [carts, posisi]);

  const posisiOpt = [
    { value: "PLATINUM", label: "PLATINUM", bv: 4 },
    { value: "SILVER", label: "SILVER", bv: 2 },
    { value: "BRONZE", label: "BRONZE", bv: 1 },
  ];


  const watchGudang = watch("gudang_id");
  const watchJenisPengiriman = watch("jenis_pengiriman");
  const [valueItem, setValueItem] = useState(4)


  const handlePosisiChange = (e) => {
    const selectedPosisi = posisiOpt.find(option => option.value === e.target.value);
    setPosisi(selectedPosisi.value);
    setValueItem(selectedPosisi.bv);
    setCarts([]);
    setOptEkspedisi([]);
    setOptLayanan([]);
  };

  useEffect(() => {
    if (carts?.length && watchJenisPengiriman) {
      dispatch(
        fetchGudangStok({
          carts: carts.map(({ public_id: id, qty }) => ({ id, qty })),
          is_online_pickup: watchJenisPengiriman === "delivery" ? 1 : null,
          is_offline_pickup: watchJenisPengiriman === "pickup" ? 1 : null
        })
      );
    }
  }, [dispatch, carts, watchJenisPengiriman]);


  const closeForm = () => {
    setIsOpen(false);
    setFormAddress(null);
  };

  const closeModal = () => {
    setModal(false);
  };

  const submit = (data, action) => {
    if (action === "delete") {
      dispatch(deleteAccountAddress(data.public_id));
      dispatch(setFormOrder(tempDeletedAddress))
      setModal(false);
      setSelected(null)
      return;
    }

    // if (!data.id_alamat_domestic) {
    //   toast.error("Alamat belum dilengkapi");
    //   return;
    // }

    if (data.public_id && data.public_id !== "") {
      dispatch(updateAccountAddress(data.public_id, data));
      setSelected(null)
    } else {
      dispatch(createAccountAddress(data));
    }
    setModal(false);
    setSelectedSearchAddress(null);
  };


  const tempDeletedAddress = {
    ...formOrder,
    steps: formOrder?.steps?.map((a) => {
      if (a.name === 'delivery') {
        return {
          ...a,
          data: null
        };
      }
      return a;
    }, []),
  };

  const onSelectAlamat = (data) => {
    setSelected(data);
    setModal(false);

    const tmp = {
      ...formOrder,
      steps: formOrder?.steps?.map((a) => {
        if (a.name === "delivery") {
          return {
            ...a,
            passed: false,
            data: {
              ...data,
              gudang: gudang?.find((a) => a.public_id === watchGudang, null),
            },
          };
        }
        return a;
      }, []),
    };
    dispatch(setFormOrder(tmp));
  };

  useEffect(() => {
    if (
      !selected ||
      carts?.length === 0 ||
      !watchGudang ||
      !gudang ||
      !watchJenisPengiriman ||
      watchJenisPengiriman !== "delivery"
    )
      return;
    const origin = gudang?.find(
      (a) => a.public_id === watchGudang,
      null
    )?.id_alamat;
    if (!origin) return;

    setOptEkspedisi([]);
    setOptLayanan([]);

    dispatch(
      fetchShipping({
        originType: "subdistrict",
        origin: origin,
        // destination_id: selected?.alamat_domestic?.id_alamat,
        kelurahan_id: selected?.kelurahan_id,
        weight: carts?.reduce((a, b) => a + b.qty * b.berat, 0),
        gudang_id: watchGudang,
        bv: carts?.reduce((a, b) => a + b.value * b.qty, 0),
      })
    );
  }, [
    selected,
    carts,
    watchGudang,
    gudang,
    watchJenisPengiriman,
    dispatch,
  ]);

  useEffect(() => {
    setValue("ekspedisi", "");
    setValue("layanan", "");
  }, [watchGudang, watchJenisPengiriman]);

  function getBestCourier(shipping) {
    if (!shipping || !Array.isArray(shipping.courier)) {
      return null;
    }

    // Fungsi bantu untuk parsing etd (ambil nilai terendah dari string etd)
    function parseEtd(etd) {
      if (typeof etd !== "string") return Infinity;
      const numbers = etd.match(/\d+/g);
      return numbers && numbers.length > 0 ? parseInt(numbers[0], 10) : Infinity;
    }

    // Mapping ekspedisi dengan etd yang diparsing
    const enrichedCouriers = shipping.courier.map(courier => ({
      ...courier,
      etdDays: parseEtd(courier.etd)
    }));

    // Filter hanya yang etdDays >= 1
    const validCouriers = enrichedCouriers.filter(c => c.etdDays > 1);
    if (validCouriers.length === 0) {
      return null;
    }

    // Cari estimasi pengiriman tercepat dari yang valid
    const minEtd = Math.min(...validCouriers.map(c => c.etdDays));

    // Filter kandidat yang punya estimasi tercepat
    const fastestCouriers = validCouriers.filter(c => c.etdDays === minEtd);

    // Dari yang tercepat, ambil yang paling murah
    const bestCourier = fastestCouriers.reduce((prev, curr) =>
      curr.cost < prev.cost ? curr : prev
    );

    return bestCourier;
  }

  useEffect(() => {
    const bestShippingOption = getBestCourier(shipping);
    if (bestShippingOption && bestShippingOption.code && bestShippingOption.name) {
      setOptEkspedisi([
        {
          value: bestShippingOption.code,
          label: bestShippingOption.name,
          data: bestShippingOption
        }
      ]);
    } else {
      setOptEkspedisi([]);
    }

    const { values, ...datasub } = shipping?.subsidi || {};
    const isGudangSub = values?.find(
      (sub) => sub?.gudang?.public_id === watchGudang
    );

    if (!isGudangSub) return;

    const totalBv = carts?.reduce((a, b) => a + b.qty * b.value, 0);
    const qualifiedBv = isGudangSub.values
      .sort((a, b) => b.bv - a.bv, [])
      .find((a) => totalBv >= a.bv);

    if (!qualifiedBv) return;

    setSubsidiOngkir({
      ...datasub,
      ...isGudangSub,
      nominal:
        datasub?.jenis === "PERSENTASE"
          ? Math.floor(
            (carts?.reduce((a, b) => a + b.qty * b.dpp, 0) *
              (Number(qualifiedBv.value) / 100)) /
            1000
          ) * 1000
          : Number(qualifiedBv.value),
    });
  }, [shipping]);

  const [ongkos, setOngkos] = useState(null)
  useEffect(() => {
    const optLayanan = optEkspedisi?.map((layanan) => {
      if (layanan.value === watchEkspedisi?.value) {
        const cost = layanan.data.cost
        const potongan = subsidiOngkir
          ? Math.min(subsidiOngkir.nominal, cost)
          : 0;
        setOngkos(subsidiOngkir ? (cost - potongan) : cost)
        return {
          value: layanan?.data?.service,
          label: (
            <div>
              <div>
                {layanan.data.service} - {layanan.data.description} - {layanan.data.etdDays} hari
              </div>
              <div>
                {subsidiOngkir ? (
                  <>
                    <strike>{formatCurrency(cost)}</strike>&nbsp;
                    {formatCurrency(cost - potongan)}
                  </>
                ) : (
                  formatCurrency(cost)
                )}
              </div>
            </div>
          )
        };
      }
      return []
    })

    setOptLayanan(optLayanan)
    setMyEkspedisi(
      shipping?.ekspedisi?.find((a) => a.kode === watchEkspedisi?.value)
    );
  }, [watchEkspedisi, optEkspedisi, setValue, shipping]);

  useEffect(() => {
    setValue(
      "is_asuransi",
      (myEkspedisi?.asuransi_fix || myEkspedisi?.asuransi_persen) &&
        myEkspedisi.wajib_asuransi
        ? true
        : false
    );
  }, [myEkspedisi, setValue]);

  useEffect(() => {
    setValue('ekspedisi', '')
    setValue('layanan', '')
  }, [selected, optEkspedisi, setValue]);


  return (
    <>
      <div>
        <PageHeading title={title} />
        <CardBasic>
          <div className="card mb-2 p-3">
            <h5 className='border-bottom py-2 mb-4' style={{ color: '#3d405c' }}>
              Pilih Alamat
            </h5>
            <div className="card-body m-n2">
              {!selected ? (
                <span className='text-secondary'>Silahkan pilih alamat pengiriman</span>
              ) : (
                <>
                  <div>
                    {selected?.nama} ({selected?.phone}){" "}
                    <span className="badge badge-info">{selected?.label}</span>
                  </div>
                  <div>
                    {selected?.alamat}. Kecamatan {selected?.kecamatan},
                    Kabupaten/Kota {selected?.kota}, Propinsi{" "}
                    {selected?.propinsi}. Kode Pos {selected?.kode_pos}
                  </div>
                </>
              )}
              <div className="mt-2">
                <button
                  type="button"
                  className="btn btn-primary-f mb-2 btn-sm"
                  onClick={() => {
                    if (address?.rows?.length > 0) {
                      setModal(true);
                    } else {
                      setIsOpen(true);
                    }
                  }}
                >
                  {address?.rows?.length > 0 ? "Pilih Alamat" : "Tambah Alamat"}
                </button>
              </div>
            </div>
          </div>

          <div className='border p-3' style={{ borderRadius: "5px" }}>
            <h5 className="border-bottom py-2 mb-4" style={{ color: "#3d405c" }}>
              Pilih Tipe
            </h5>
            <div className="row">
              <div className="col-sm-12 col-md-6">
                <div className="form-group">
                  <label htmlFor="exampleFormControlSelect1">Tipe Calon Member</label>
                  <select
                    className="form-control"
                    id="exampleFormControlSelect1"
                    onChange={handlePosisiChange}
                    value={posisi}
                  >
                    {posisiOpt.map((option) => (
                      <option key={option.value} value={option.value}>{option.label}</option>
                    ))}
                  </select>

                </div>
              </div>
            </div>
          </div>
          <div className='border p-3 mt-2' style={{ borderRadius: "5px" }}>
            <h5 className='border-bottom py-2 mb-4' style={{ color: '#3d405c' }}>
              Pilih Paket/Item
            </h5>
            <div className='row row-cols-1 row-cols-sm-2 row-cols-md-4 mt-4'>
              {barang?.rows
                ?.filter((a) => a.value <= valueItem, [])
                ?.sort((a, b) => { return b.value - a.value })
                ?.map((item, index) => {
                  const cart = carts?.find((a) => a.public_id === item.public_id);
                  return (
                    <div className='col mb-4' key={item.public_id}>
                      <div className='card custom-card d-flex'>
                        {item.gambars[0]?.lokasi ? (
                          <img
                            className='card-img-top'
                            src={item.gambars[0]?.lokasi}
                            alt='Card cap'
                            onClick={(e) => handleViewItemDetail(item, e)}
                            style={{ cursor: 'pointer' }}
                          />
                        ) : (
                          <Skeleton height={150} />
                        )}
                        <div className='card-body' style={{ cursor: 'pointer' }}>
                          <h6 className='card-title text-two-line'>{item.nama}</h6>
                          <div className='d-md-flex mb-3 mt-2 justify-content-between d-sm-block'>
                            <div className='card-title font-weight-bold py-1'>
                              {formatCurrency(item.harga)}
                            </div>
                            <div className='d-flex'>
                              <button
                                style={{ width: '25px', height: '30px' }}
                                type='button'
                                className='btn btn-sm btn-primary-f flex'
                                onClick={() => handleQty(item, -1)}
                                disabled={!cart || cart?.qty < 1}
                              >
                                -
                              </button>
                              <span
                                className='border'
                                style={{
                                  width: '35px',
                                  height: '30px',
                                  textAlign: 'center',
                                  padding: '2px',
                                  borderRadius: '2px',
                                  marginRight: '1px',
                                  marginLeft: '1px',
                                }}
                              >
                                {cart?.qty || 0}
                              </span>
                              <button
                                style={{ width: '25px', height: '30px' }}
                                type='button'
                                className='btn btn-sm btn-primary-f'
                                onClick={() => handleQty(item, 1)}
                                disabled={disableMax}
                              >
                                +
                              </button>
                            </div>
                          </div>
                          <span className='badge badge-info badge-phill py-1 px-2'>
                            {item.value} BV
                          </span>
                          <div className=''>{item.deskripsi}</div>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>

          <div className='border p-3 mt-2' style={{ borderRadius: "5px" }}>
            <h5 className="border-bottom py-2 mb-2" style={{ color: "#3d405c" }}>
              Pilih Metode Pengiriman
            </h5>
            <div className="card mb-2">
              <div className="card-body">
                <div className="mb-4">
                  <TextInput
                    layout="vertical"
                    label="Jenis Pengiriman"
                    type="radio"
                    name="jenis_pengiriman"
                    defaultValue={watch("jenis_pengiriman")}
                    register={register}
                    errors={errors}
                    options={[
                      {
                        value: "delivery",
                        label: "Pengiriman Online",
                        sublabel: "Paket Dikirim menggunakan jasa kurir/ekspedisi",
                      },
                    ]}
                  />
                </div>
                {
                  watchJenisPengiriman === "delivery" ?
                    (
                      <>
                        {
                          selected && (
                            <TextInput
                              layout="vertical"
                              label={
                                watchJenisPengiriman === "delivery"
                                  ? "Asal Pengiriman"
                                  : "Lokasi Pengambilan"
                              }
                              type="radio-kebawah"
                              name="gudang_id"
                              defaultValue={watch("gudang_id")}
                              register={register}
                              errors={errors}
                              options={gudang?.map((a) => {
                                return {
                                  value: a?.public_id,
                                  label: a?.nama,
                                  sublabel: a?.lokasi,
                                };
                              }, [])}
                            />
                          )
                        }

                        <>
                          {
                            !selected && (
                              <div className="alert alert-warning">
                                Anda belum mengatur alamat
                              </div>
                            )
                          }
                          {
                            selected && carts?.length === 0 && (
                              <div className="alert alert-warning">
                                Anda harus memilih item  terlebih dahulu
                              </div>
                            )
                          }
                          {selected && carts?.length > 0 && (
                            <div className="card mb-2">
                              <div className="card-body">
                                <div className="row">
                                  <div
                                    className="col-sm-12 col-md-3"
                                    style={{ zIndex: 9999 }}>
                                    <Controller
                                      name={"ekspedisi"}
                                      control={control}
                                      render={({ field }) => (
                                        <TextInput
                                          name={"ekspedisi"}
                                          label="Ekspedisi"
                                          type="react-select"
                                          placeholder="Ekspedisi"
                                          register={register}
                                          errors={errors}
                                          field={field}
                                          options={optEkspedisi}
                                          validations={{ required: true }}
                                        />
                                      )}
                                    />
                                  </div>
                                  <div
                                    className="col-sm-12 col-md-5"
                                    style={{ zIndex: 9998 }}>
                                    <Controller
                                      name={"layanan"}
                                      control={control}
                                      // rules={{ required: true }}
                                      render={({ field }) => (
                                        <TextInput
                                          name={"layanan"}
                                          label="Layanan"
                                          type="react-select"
                                          placeholder="Layanan"
                                          register={register}
                                          errors={errors}
                                          field={field}
                                          options={optLayanan}
                                          validations={{ required: true }}
                                        />
                                      )}
                                    />
                                  </div>
                                  {myEkspedisi ? (
                                    <>
                                      <div className="col-sm-12 col-md-3">
                                        {myEkspedisi?.asuransi_fix ||
                                          myEkspedisi?.asuransi_persen ? (
                                          <TextInput
                                            disabled={myEkspedisi?.wajib_asuransi}
                                            layout="vertical"
                                            label={`Asuransi ${myEkspedisi?.wajib_asuransi
                                              ? "(Wajib)"
                                              : "(Opsional)"
                                              }`}
                                            type="switch"
                                            name="is_asuransi"
                                            placeholder=""
                                            register={register}
                                            errors={errors}
                                            value={watch("is_asuransi")}
                                            options={[
                                              {
                                                value: true,
                                                label: `Ya, ${formatCurrency(
                                                  carts?.reduce(
                                                    (a, b) => a + b.qty * b.harga,
                                                    0
                                                  ) *
                                                  (myEkspedisi?.asuransi_persen / 100) +
                                                  myEkspedisi?.asuransi_fix
                                                )}`,
                                              },
                                              { value: false, label: "Tidak" },
                                            ]}
                                          // validations={{ required: "Pilih Layanan" }}
                                          />
                                        ) : (
                                          <div>
                                            <label className="font-weight-bold">Asuransi</label>
                                            <div
                                              style={{ fontSize: "0.8rem" }}
                                              className="italic"
                                            >
                                              <i>
                                                Tidak ada opsi asuransi untuk ekpedisi{" "}
                                                {myEkspedisi?.nama}
                                              </i>
                                            </div>
                                          </div>
                                        )}
                                      </div>

                                    </>
                                  ) : (
                                    ""
                                  )}
                                </div>

                              </div>
                            </div>
                          )}
                        </>
                      </>
                    ) : ""
                }

              </div>
            </div>
          </div>
          <div className='border p-3 mt-2' style={{ borderRadius: "5px" }}>
            <table className='table' style={{ width: '100%' }}>
              <thead>
                <tr>
                  <th>Paket</th>
                  <th className='text-right'>Qty</th>
                  <th className='text-right'>BV</th>
                  <th className='text-right'>Harga</th>
                </tr>
              </thead>
              <tbody>
                {carts?.map((item, key) => {
                  return (
                    <tr key={key}>
                      <td>{item.nama}</td>
                      <td className='text-right'>{item.qty}</td>
                      <td className='text-right'>{item.qty * item.value}</td>
                      <td className='text-right'>
                        {formatCurrency(item.harga * item.qty)}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                <tr>
                  <th className='text-right'>
                    {/* SubTotal */}
                  </th>
                  <th className='text-right'>
                    {/* {carts?.reduce((a, b) => a + b.qty, 0)} */}
                  </th>
                  <th className='text-right'>
                    {/* {carts?.reduce((a, b) => a + b.qty * b.value, 0)} */}
                    Sub Total
                  </th>
                  <th className='text-right'>
                    {formatCurrency(carts?.reduce((a, b) => a + b.qty * b.harga, 0))}
                  </th>
                </tr>
                {
                  ongkos !== null && (
                    <tr>
                      <th className='text-right'></th>
                      <th className='text-right'></th>
                      <th className='text-right'>
                        Ongkir
                      </th>
                      <th className='text-right'>
                        {
                          formatCurrency(ongkos)
                        }
                      </th>
                    </tr>
                  )
                }
                {
                  watch('is_asuransi') && (
                    <tr>
                      <th className='text-right'></th>
                      <th className='text-right'></th>
                      <th className='text-right'>
                        Asuransi
                      </th>
                      <th className='text-right'>
                        {
                          myEkspedisi ? formatCurrency(
                            carts?.reduce(
                              (a, b) => a + b.qty * b.harga,
                              0
                            ) *
                            (myEkspedisi?.asuransi_persen / 100) +
                            myEkspedisi?.asuransi_fix
                          ) : ""
                        }

                      </th>
                    </tr>
                  )
                }

                <tr>
                  <th className='text-right'></th>
                  <th className='text-right'></th>
                  <th className='text-right'>
                    Total
                  </th>
                  <th className='text-right'>
                    {
                      formatCurrency(
                        ongkos +
                        (carts?.reduce((a, b) => a + b.qty * b.harga, 0)) +
                        (watch('is_asuransi') ?
                          (
                            carts?.reduce((a, b) => a + b.qty * b.harga, 0) * (myEkspedisi?.asuransi_persen / 100) +
                            myEkspedisi?.asuransi_fix
                          )
                          : 0
                        )
                      )
                    }
                  </th>
                </tr>
              </tfoot>
            </table>
          </div>
        </CardBasic >
        {
          isOpen &&
          <ModalAlamat
            toggle={() => closeForm()}
            modal={isOpen}
            data={formAddress}
            submit={submit}
          />
          // (<ModalAlamat
          //   toggle={() => closeForm()}
          //   modal={isOpen}
          //   setSelectedRow={onSelectAlamat}
          //   selectedRow={formAddress}
          //   setSelectedSearchAddress={setSelectedSearchAddress}
          //   submit={submit}
          // defaultValues={{
          //   id_alamat_domestic: null,
          //   nama: "",
          //   label: "",
          //   alamat: "",
          //   kecamatan: "",
          //   kota: "",
          //   phone: "",
          //   kode_pos: "",
          //   public_id: "",
          //   provinsi: "",
          //   kelurahan: "",
          // }}
          //  />)
        }

        <Modal
          toggle={() => closeModal()}
          isOpen={modal}
          centered={true}
          size={"lg"}
        >
          <ModalHeader
            toggle={() => closeModal()}
            close={
              <div className="btn close" onClick={() => closeModal()}>
                ×
              </div>
            }
          >
            Pilih Alamat
          </ModalHeader>
          <ModalBody>
            <div className="modal-body">
              <button
                type="button"
                className="btn btn-primary-f mb-2 btn-sm"
                onClick={() => {
                  setIsOpen(true);
                  setIsOpen(true);
                  setSelectedSearchAddress(null)
                  setSelected(null)
                }}
              >
                Tambah Alamat
              </button>
              <div className="list-group mb-4">
                {address?.rows?.map((item, ix) => {
                  return (
                    <CardAlamat
                      key={ix}
                      data={item}
                      selected={selected}
                      onSelectAlamat={onSelectAlamat}
                      action={true}
                      setFormAddress={setFormAddress}
                      setIsOpen={setIsOpen}
                    />
                  );
                })}
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div >
      <ModalDetailItem
        data={modalData}
        isOpen={detailProduct}
        setIsOpen={setDetailProduct}
        handleSubmit={handleSubmit}
      />
    </>
  );
};



export default CekOngkir;
